/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Generate_Expirycustomlabel4Inputs */

const en_settings_reportingapikeys_generate_expirycustomlabel4 = /** @type {(inputs: Settings_Reportingapikeys_Generate_Expirycustomlabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom expiry in days (max 365)`)
};

/**
* | output |
* | --- |
* | "Custom expiry in days (max 365)" |
*
* @param {Settings_Reportingapikeys_Generate_Expirycustomlabel4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_generate_expirycustomlabel4 = /** @type {((inputs?: Settings_Reportingapikeys_Generate_Expirycustomlabel4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Generate_Expirycustomlabel4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_generate_expirycustomlabel4(inputs)
});
export { settings_reportingapikeys_generate_expirycustomlabel4 as "settings_reportingApiKeys_generate_expiryCustomLabel" }